var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffect, useState } from 'react';
import { Input, Range } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { PERIOD_STEP } from '@app/configs/calculator';
const RangeSelect = ({ title, min, max, onSelect, loanPeriod, loanAmount, isPeriodValid, setErrors, errors, }) => {
    var _a, _b;
    const { t } = useTranslation();
    const [value, setValue] = useState(loanPeriod);
    const validatePeriod = (period) => {
        if (period < min) {
            setErrors((currentErrors) => (Object.assign(Object.assign({}, currentErrors), { period: { state: true, message: t('financing.demo_calculator_min_period', { month: min }) } })));
            return false;
        }
        if (period > max) {
            setErrors((currentErrors) => (Object.assign(Object.assign({}, currentErrors), { period: { state: true, message: t('financing.demo_calculator_max_period', { month: max }) } })));
            return false;
        }
        onSelect(period);
        if (!isPeriodValid(period)) {
            setErrors((currentErrors) => (Object.assign(Object.assign({}, currentErrors), { period: { state: true, message: t('financing.demo_calculator_invalid_period') } })));
            return false;
        }
        setErrors((_a) => {
            var { period: periodErrors } = _a, restErrors = __rest(_a, ["period"]);
            return (Object.assign({}, restErrors));
        });
        return true;
    };
    useEffect(() => {
        setValue(loanPeriod);
        validatePeriod(loanPeriod);
    }, [loanPeriod, loanAmount]);
    const handleBlur = () => {
        validatePeriod(value);
    };
    const handleChange = (event) => {
        var _a, _b;
        const enteredValue = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.replace(/[^0-9]/g, '');
        setValue(Number(enteredValue));
    };
    const handleUpdateRange = (rangeValue) => {
        if (validatePeriod(rangeValue)) {
            onSelect(rangeValue);
        }
    };
    return (<div className="flex flex-col gap-2">
            <div className="label-m">{title}</div>
            <Input id="loanPeriod" onBlur={handleBlur} onChange={handleChange} label={title} value={value} isError={!!((_a = errors === null || errors === void 0 ? void 0 : errors.period) === null || _a === void 0 ? void 0 : _a.state)} hintText={(_b = errors === null || errors === void 0 ? void 0 : errors.period) === null || _b === void 0 ? void 0 : _b.message}/>
            <Range min={min} max={max} marks={[
            {
                label: `${t('financing.demo_calculator_min')}: ${min} ${t('financing.demo_calculator_month')}`,
                value: min,
            },
            {
                label: `${t('financing.demo_calculator_max')}: ${max} ${t('financing.demo_calculator_months')}`,
                value: max,
            },
        ]} onChange={handleUpdateRange} value={loanPeriod} step={PERIOD_STEP}/>
        </div>);
};
export default RangeSelect;
